export default {

  // ダイアログ タイトル
  /** 情報 : 情報表示（処理終了等）、ガイダンス等 */
  'dialog.title.I': '確認',
  /** 警告 : 入力チェックでの警告（処理継続可） */
  'dialog.title.W': '警告',
  /** エラー : 入力チェック、処理実行時のエラー（処理継続不可） */
  'dialog.title.E': '注意',
  /** 確認 : 処理継続の確認メッセージ */
  'dialog.title.C': '確認',
  /** システムエラー : サーバ、ネットワーク等の環境によるエラー 予期しないエラー */
  'dialog.title.S': 'システムエラー',

  // メッセージ
  // 共通
  'message.BFZ000001S': 'システム異常が発生しました。\nしばらく待って再度やり直してください。',
  'message.BFY000002C': '入力中のデータを破棄して前画面に戻ります。\nよろしいですか。',
  'message.BFY000003C': '画面を閉じます。よろしいですか。',
  'message.BFY000004C': '登録します。よろしいですか。',
  'message.BFY000005C': '{0}します。よろしいですか。',
  'message.BFY000006C': '{0}を{1}します。よろしいですか。',
  'message.BFY000007C': '{0}を取込みます。よろしいですか。',
  'message.BFY000008C': '「{0}」を削除します。よろしいですか。',
  'message.BFY000009I': '{0}しました。',
  'message.BFY000011I': '選択した添付ファイル({0})を削除しました。',
  'message.BFY000012I': '{0}を添付（アップロード）しました。',
  'message.BFY000013I': '{0}を出力（ダウンロード）しました。',
  'message.BFY000013W': '入力内容が編集されています。保存せずに続行しますか。',
  'message.BFY000014W': '{0}が{1}に存在しませんが、続行しますか。',
  'message.BFY000015E': '検索結果の件数が{0}件を超えています。検索条件を追加、変更してください。',
  'message.BFY000015W': '対象件数過多のため先頭の{0}件を表示します。',
  'message.BFY000016E': '検索条件に合致するデータはありません。',
  'message.BFY000017E': '{0}を入力してください。{1}',
  'message.BFY000018E': '{0}を添付（アップロード）してください。{1}',
  'message.BFY000019E': '{0}は1件以上入力してください。',
  'message.BFY000020E': '{0}≦{1}の関係になるように入力してください。',
  'message.BFY000021E': '{0}から{1}の間になるように入力してください。',
  'message.BFY000022E': '1件のみ選択してください。',
  'message.BFY000023E': '{0}対象を選択してください。',
  'message.BFY000024E': '{0}が{1}の場合、{2}を入力してください。',
  'message.BFY000025E': '{0}は、いずれかを選択してください。',
  'message.BFY000026E': '{0}は、{1}の範囲で入力してください。{2}',
  'message.BFY000027E': '{0}を選択してください。',
  'message.BFY000028E': '選択したファイルのサイズが大きすぎます。{1}MB以内のファイルを選択してください。{0}',
  'message.BFY000029E': '選択したファイルが読み込めません。ファイルのアクセス権限を確認してください。',
  'message.BFY000030E': '選択したファイルにマクロを検出しました。ファイルを確認してください。{0}',
  'message.BFY000031E': '選択したファイルは、{0}のレイアウトではありません。',
  'message.BFY000032E': '{0}取込先フォルダ名を選択してください。',
  'message.BFY000033E': '{0}が{1}に存在しません。',
  'message.BFY000034E': '{0}は既に登録済みです。',
  'message.BFY000035E': '{0}は数値を入力してください。',
  'message.BFY000036E': '{0}に正しい日付を入力してください。',
  'message.BFY000037E': '{0}は正しい時刻を入力してください。',
  'message.BFY000038E': '{0}は未来の日付を入力してください。',
  'message.BFY000039E': '既に申込しています。',
  'message.BFZ000040E': '期限({0}日前)を超過しています。',
  'message.BFY000041E': '{0}の桁数が超過しています。{1}',
  'message.BFY000042E': '{0}は半角数字のみ入力してください。',
  'message.BFY000043E': '{0}は全角ひらがなのみ入力してください。',
  'message.BFY000044E': '{0}は正しいフォーマットで入力してください。',
  'message.BFY000045E': '開始日は終了日以前に設定してください。',
  'message.BFY000046E': '{0}は半角文字のみで入力してください。',
  'message.BFY000047E': '他のユーザーによって更新されています。操作をやり直してください。',
  'message.BFY000048E': 'ファイル取込でエラーが発生しました。ファイル名:{0}, 行数:{1}, カラム:{2}, {3}',
  'message.BFY000049E': '入力に誤りがあります。入力内容を確認してください。',
  'message.BFY000050E': '{0}は整数{1}桁、小数{2}桁の精度以内の数値を入力してください。',
  'message.BFY000051E': '{0}の{1}に失敗しました。',
  'message.BFY000052E': '{0}は、{1}のため選択できません。{2}',
  'message.BFY000053E': '登録可能な最大件数({0})を超過するため登録できません。',
  'message.BFU000054E': '{0}を操作する権限がありません。',
  'message.BFY000055E': '{0}ため{1}できません。',
  'message.BFY000056E': '{0}は許可されていないファイル形式です。',
  'message.BFY000057E': 'ファイルの件数が上限を超えています。',
  'message.BFY000058E': 'ファイル添付先がありません。{0}を保存してください。',
  'message.BFA000059E': '{0}は代表電柱と同じ営業所にしてください。{1}',
  'message.BFA000060W': '離隔不足です。設備設置位置を見直してください。{0}:{1}',
  'message.BFA000061W': '※注意※　{0}m未満に接近する場合、当該共架物の施設者に近接設置についての承諾が必要です。({1}:{2})',
  'message.BFA000062E': '引込線は電柱から１ｍ以上離した位置から分岐させてください。({0}:{1})',
  'message.BFA000063E': '改修工事ステータスが「工事完了」ではありません。',
  'message.BFA000064E': '設備の登録がありません。',
  'message.BFA000065E': '共架事業者の共架物件種類と申込の共架物件種類が一致しません。',
  'message.BFZ000068I': 'ただいま承認申請中です。',
  'message.BFZ000069I': '申込を差戻しました。',
  'message.BFZ000070I': '申込を確定しました。',
  'message.BFY000073E': 'ファイル名が{0}文字を超えています。',
  'message.BFY000074E': 'ファイルが空です。',
  'message.BFY000075E': '{0}は既に登録されています。ファイル名を変更してください。',
  'message.BFY000076E': 'ファイルの登録/削除が行われていません。',
  'message.BFY000077E': '写真のアップロードに失敗しました。再度やり直してください。',
  'message.BFY000078W': '本画面でエラーが残っている状態で保存しています。登録までにエラーを取り除いてください。',
  'message.BFU000079E': '契約終了日は契約開始日以降に設定してください。',
  'message.BFY000080E': 'この項目は変更できません。',
  'message.BFY000081E': 'ファイルのアップロードに失敗しました。再度やり直してください。',
  'message.BFY000082E': '{0}のため{1}できません。電柱番号:{2}',
  'message.BFY000083E': '{0}ステータスが「{1}」に至っていません。',
  'message.BFY000084E': '{0}を入力した場合、{1}を入力してください。',
  'message.BFY000085E': '{0}が1件ではありません。',
  'message.BFY000086E': '一定時間操作されなかったため、ダッシュボードに戻ります。',
  'message.BFY000087E': '承認申請中のため、編集できません。',
  'message.BFY000088C': '{0}\nの代行入力を{1}します。よろしいですか。',
  'message.BFY000089I': '{0}\nの代行入力を{1}しました。',
  'message.BFY000091E': 'セッションの有効期限が切れました。\n恐れ入りますが、最初からやり直してください。',
  'message.BFY000092E': 'アクセスが集中しております。少し時間をおいて再度アクセスをお願いします。',
  'message.BFY000093E': 'ファイルのサイズが上限を超えています。',
  'message.BFY000094E': '許可されていないファイル形式です。',
  'message.BFZ000095E': '申込を差戻しできません。',
  'message.BFY000096C': '申込を取止めます。よろしいですか。',
  'message.BFY000097E': '{0}が、{1}のため、編集できません。',
  'message.BFY000098E': '{0}を添付（アップロード）してください。',
  'message.BFY000099E': '{0}が未設定です。{0}を設定し、保存してください。',
  'message.BFY000100E': '{0}を添付（アップロード）してください。{1}',
  'message.BFY000101E': '{0}は本日以前の日付を入力してください。{1}',
  'message.BFY000102E': '{0}が、{1}のため、入力できません。',
  'message.BFY000103W': '共架担当者が未設定のため、メールの送信を行えませんでした。',
  'message.BFU000104E': '{0}は削除されたユーザです。',
  'message.BFU000105E': '{0}は登録済みのユーザです。',
  'message.BFZ000107E': '発行日が設定済みです。',
  'message.BFY000108I': 'キャンセルしました。',
  'message.BFY000109I': '{0}が完了しました。\n{0}受付後、{1}メールを送信します。',
  'message.BFZ000110E': '通信に失敗しました。再度実行してください。',
  'message.BFU000111W': '通知先のメールアドレスが未設定のため、{0}が行えませんでした。',
  'message.BFU000112E': '承認者が取得できませんでした。ユーザ管理者に承認者の設定を確認してください。',
  'message.BFU000113E': '権限エラー：他の営業所のデータは処理できません。',
  'message.BFY000114W': 'エラーが残っています。{0}までに、本画面に戻って入力内容を修正してください。',
  'message.BFY000115E': 'エラーが残っているため{0}できません。{1}入力内容を修正してください。',
  'message.BFY000116E': '{0}を保存してください。',
  'message.BFY000118W': '入力内容が編集されています。保存して{0}しますか。',
  'message.BFE000119E': '契約区分が{0}の為、保存できませんでした。',
  'message.BFY000120E': '{0}文字以内で入力してください。',
  'message.BFA000121E': '中電PG工事希望_内容が無しではない場合、技術検討結果に可を入力することはできません。',
  'message.BFY000122E': 'ファイルにウィルスを検出したため、アップロードできません。{0}',
  'message.BFY000123E': '{0}を保存していないため、{1}を入力できません。',
  'message.BFA000125E': '作成中以外の共架申込（{0}）は削除できません。',
  'message.BFY000127E': 'エラーが残っているため、{0}できません。',
  'message.BFU000130E': '新規申込制限中（約款違反）のため、新規申込できません。',
  'message.BFU000131E': '新規申込制限中（約款未承諾）のため、新規申込できません。',
  'message.BFA000132E': '第一・第二電柱が同一電柱です。',
  'message.BFU000139E': 'メールアドレスが登録されていないため、登録してください。',
  'message.BFZ000140E': '本システムはただ今ご利用頂けません。\nご利用可能な時間帯は {0} ～ {1} となっております。',
  'message.BFZ000141E': 'ネットワークエラーが発生しました。\n数分待ってから操作してください。\n再度ネットワークエラーが発生する場合は管理者に連絡してください。',
  'message.BFA000143E': '電柱本数の上限に達しています。',
  'message.BFZ000144E': '対象ファイルは削除済みです。',
  'message.BFY000148W': '入力内容が編集されています。{0}しますか。',
  'message.BFY000166W': '出力対象の件数が{0}件を超えています。CSV出力に時間がかかります。よろしいですか。',
  'message.BFY000167E': '作成中以外の件名は削除できません。',
  'message.BFY000174I': '撮影日から３か月以上経過した写真です。',
  'message.BFY000175I': '撮影日が共架工事完了日から２か月以上経過しています。',
  'message.BFY000176E': '適用終了日と適用開始日が連続していないため、適用されない期間が発生します。',
  'message.BFY000178W': '{0}は、{1}の範囲で入力してください。{2}',
  'message.BFY000179E': '{0}と{1}の内容は一致させてください。',
  'message.BFY000181E': '適用期間が重複しています。適用日の範囲が被らないようにしてください。',
  'message.BFY000184E': '{0}は{1}以前を入力してください。{2}',
  'message.BFY000187E': '{0}は過去の日付を入力してください。{1}',
  'message.BFA000190E': '申込が旧版のため、{0}できません。',
  'message.BFY000191E': '入力形式が間違っています。',
  'message.BFY000194E': 'ファイル取込でエラーが発生しました。ファイル名:{0}, シート名:{1}, :{2}, カラム:{3}, {4}',
  'message.BFY000198E': '{0}に存在しないコード値が指定されています。',
  'message.BFY000199E': 'キー項目が重複しているデータが存在します。',
  'message.BFZ000204E': 'アップロードファイルの文字コードは{0}を指定してください。',
  'message.BFZ000205E': 'ファイルフォーマットが異なります。ファイルの内容を確認の上、再度実行してください。',
  'message.BFZ000206E': '一括登録可能な件数を超えています。{0}件以下となるように修正してください。',
  'message.BFY000213E': 'ファイル取込でエラーが発生しました。{0}',
  'message.BFY000221E': '{0}は全角カタカナのみ入力してください。',
  'message.BFA000225E': '離隔不足です。{0}を修正してください。',
  'message.BFA000226W': '離隔が閾値を超えています。{0}の値が正しいか確認してください。{1}',
  'message.BFY000229E': '事業場を選択してください。',
  'message.BFM000236W': '占有サイズ {0} の登録を行ってください。',
  'message.BFI000237E': '承認依頼が行えませんでした。',
  'message.BFI000238W': '承認依頼は行いましたが、通知は行えませんでした。',
  'message.BFZ000239E': '仕掛かり中の申込があるため削除できません。',
  'message.BFY000247E': '{0}にエラーがあります。入力内容を修正してください。',
  'message.BFY000248W': '{0}に警告があります。入力内容を確認してください。',
  'message.BFY000249C': '{0}に警告があります。{1}してもよろしいですか。',
  'message.BFB000246E': '開始時刻は終了時刻以前に設定してください。',
  'message.BFU000248I': '基本契約書の内容を承りました。',
  'message.BFU000249I': '基本契約書の内容を変更しました。契約書出力により内容をご確認ください。',
  'message.BFZ000251W': '適用終了日が9999/12/31のデータを追加してください。',
  'message.BFZ000252C': '重要事項の確認・回答は再度行う事ができません。処理を継続してよろしいですか？',
  'message.BFM000253E': '通信設備に占有サイズは指定できません。',
  'message.BFM000254E': '機器設備に一束化区分は指定できません。',
  'message.BFM000255W': '適用開始日に過去日が設定されています。処理済の過去のデータには反映されません。',
  'message.BFM000257E': '会社コード／会社区分はいずれか一つ指定してください。',
  'message.BFY000271W': '{0}が未設定です。画面を確認してください。{1}',
  'message.BFZ000289E': '{0}:{1}は他設備のIDと重複しています。',
  'message.BFY000299E': '{0}は{1}以降を入力してください。',
  'message.BFZ000302I': '業務時間外になりました。\n照会系の画面のみご利用いただけます。',
  'message.BFM000304E': '過去日の登録はできません。',
  'message.BFM000330E': '単価は整数を入力してください。',
  'message.BFZ000313I': '業務時間になりました。\nメニュー項目を更新します。',
  'message.BFU000332I': 'ユーザー情報が更新されています。\n再度やり直してください。',
  'message.BFY000336E': '対象件数過多によりタイムアウトしました。\n検索条件による絞り込みを行って再度実行してください。',
  'message.BFY000337E': '該当データが存在しないか、アクセス許可がありません。',
  'message.BFY000399E': '電柱の緯度、経度を取得できないため、分岐点・未登録電柱の緯度、経度を設定できません。別の電柱を選択してください。{0}',
  'message.BFY000400E': '分岐点・未登録電柱の緯度、経度が未設定です。電柱を選択し、方位角、距離を入力してください。{0}',
  'message.BFY000402E': '架設設備（{0}{1}）が事業者毎架設設備に存在しません。\n共架者基本情報(編集)操作で架設設備を追加してください。{2}',

  // 共架申込
  'message.BFA000066E': '申込電柱({0})はすでに契約しているため、同じポジションには新規で取付できません。{1}',
  'message.BFA000067E': '申込電柱({0})は契約していないため、新規で取付してください。{1}',
  'message.BFA000117E': '申込電柱の一束化（{0}）と一束化相手先共架事業者数が一致しません。申込電柱の一束化または一束化相手先共架事業者を修正してください。{1}',
  'message.BFA000124E': '共架申込（{0}）は削除できません。',
  'message.BFA000126E': '同じ一束化相手先を選択しています。{0}',
  'message.BFA000128E': '{0}は申込ステータスが技術検討中または改修設計中でないため、共架内諾書をダウンロードできません。',
  'message.BFA000129E': '{0}は技術検討済でないため、技術検討結果回答書をダウンロードできません。',
  'message.BFA000153I': '{0}を取止めます。\n以下の改造工事費用の請求が確定済みのため、確認してください。\n{1}',
  'message.BFA000154I': '改造工事費用の請求が確定済みのため、確認してください。',
  'message.BFA000156E': '一束化対象外の共架種別を選択しているため、一束化できません。{0}',
  'message.BFA000157W': '申込代行、是正申込が未チェックです。',
  'message.BFA000158W': '通信線の共架に必要な設備（吊線、支持線等）が未登録です。{0}',
  'message.BFA000159E': '他共架者が使用中のポジションのため単独での申込はできません。{0}',
  'message.BFA000160E': '径間に登録されていない通信設備の電柱があります。電柱番号:{0}',
  'message.BFA000161W': '径間が途中で途切れています。このまま登録しますか。',
  'message.BFA000163E': '該当ポジションに通信設備の新設申込が仕掛中のため、増条のみ可能です。{0}',
  'message.BFA000164E': '既設設備情報の確認が未完了です。',
  'message.BFA000177E': '関連工事伝票の紐付け状態を更新してください。{0}',
  'message.BFA000180E': '同一電柱の共架物件の一束化区分が異なる場合、異なるポジションを入力してください。{0}',
  'message.BFA000182C': '技術検討費用請求{0}の電柱です。請求費用{1}に変更します。よろしいですか。',
  'message.BFA000185E': '{0}の確認が未完了です。',
  'message.BFA000186W': '共架者申込番号{0}が、過去の申込と重複しています。',
  'message.BFA000188E': '申込ステータスが{0}のため、申込取消できません。',
  'message.BFA000189E': '申込ステータスが{0}でないため、申込取止できません。',
  'message.BFA000192C': 'しゅん工時の値をクリアします。よろしいですか。',
  'message.BFA000193I': '共架承認してから一定期間が経過してもしゅん工報告が行われない共架申込が著しく多い場合、共架承認を取下し、以降の共架申込の受付を停止する場合があります。',
  'message.BFA000195E': '技術検討費用請求対象の設備の、技術検討要否が否です。請求対象から外すか技術検討要否を要にしてください。{0}',
  'message.BFA000196E': '改修が必要な支持物に対して、重複せずに１箇所登録してください。({0}:{1})',
  'message.BFA000197E': '共架承認後または改修工事完了から2か月経過しているため、取消できません。',
  'message.BFA000200E': '共架本申込登録開始可能日から２か月経過していますのでこの申込は無効です。\n申込内容を修正し、技術検討から再申込を行ってください。',
  'message.BFA000201W': '{1}の項目が未入力です。{0}',
  'message.BFA000202E': '吊線所有共架事業者との合意情報が未登録です。{0}',
  'message.BFA000207E': '変更連絡票が未登録です。',
  'message.BFA000208E': '伝票情報は配電または通信の一方のみを登録してください。{0}',
  'message.BFA000209E': '配電の改修内容は単価制または2024年度以前の項目の一方のみを登録してください。{0}',
  'message.BFA000210E': '外線伝票番号と引内工事番号は一方のみを登録してください。{0}',
  'message.BFA000211E': '技術検討結果により共架申込できません。{0}',
  'message.BFA000212E': '改修設計（予定）が未登録の場合、実績を登録する事はできません。{0}',
  'message.BFA000215E': '共架申込承認済みのため、共架仮承認書はダウンロードできません。',
  'message.BFA000216E': '共架申込未承認のため、共架承認書はダウンロードできません。',
  'message.BFA000219E': '技術検討可条件が「他社設備改修（合意済）」の場合、改修設計要を登録することはできません。',
  'message.BFA000220E': '選択した既設設備は一覧に存在します。他の既設設備を選択してください。',
  'message.BFA000222E': '申込径間（中電柱）のポジションリンクをすべて登録してください。',
  'message.BFD000223E': '街路灯とその他設備を同時に登録することはできません。',
  'message.BFD000224E': '複数の事業場が管理する電柱を同時に登録することはできません。',
  'message.BFE000228E': '入金金額は請求残高金額と不一致なります。正しい金額を入力してください。',
  'message.BFE000230E': '個別費用請求・払戻の元となった請求が未入金ので、摘要が共架料払戻に設定しないでください。',
  'message.BFA000243E': '第一・第二電柱の組み合わせは申込できません。{0}',
  'message.BFA000244E': '径間の繋がりがありません。電柱番号:{0}',
  'message.BFA000245W': '径間の繋がりが不足しています。電柱番号:{0}',
  'message.BFA000246E': '同じ径間は登録できません。{0}',
  'message.BFA000247I': '"配電の改修設計が必要な申込を承認する場合は、\n改修伝票の回付をおこなってください。」"',
  'message.BFA000256E': '通信設備に存在しない電柱が径間にあります。電柱番号:{0}',
  'message.BFA000258E': '吊線所有共架事業者が一束化協定に合意していないため、吊線共用協定書を添付してください。',
  'message.BFA000259W': '技術検討費用請求対象ではありませんが、技術検討要否が要になっています。{0}',
  'message.BFA000272E': '径間が未設定です。第一電柱、または第二電柱を設定してください。{0}',
  'message.BFA000273E': '伝票区分が「配電新設」の伝票は１つのみ登録してください。',
  'message.BFA000274E': '電柱番号{0}に複数設備の登録がありますが、先行建柱区分が一致していません。',
  'message.BFA000282E': '改修工事予定のため、取消できません。共架受付センターへお問合せ下さい。',
  'message.BFA000283C': '改修工事の予定があります。精算不要の場合は、取消に進んでください。',
  'message.BFA000284E': '設備が支持物以外なので、分割申込番号を入力できません。{0}',
  'message.BFA000291E': '技術検討結果が共架可能（条件有り）の時、共架者申込の修正要否と共架条件が矛盾しないように入力してください。{0}',
  'message.BFA000292E': '登録します。よろしいですか？改修設計が必要です。BOの操作を行ってください。',
  'message.BFA000300E': '工事伝票の情報が無い場合は保存できません。{0}',
  'message.BFA000306I': '施設確認結果「不適」の通知を行ってから一定期間が経過してもしゅん工報告が行われない共架申込が著しく多い場合、共架承認を取下し、以降の共架申込の受付を停止する場合があります。',
  'message.BFA000314E': '電柱番号{0}に複数設備の登録がありますが、{1}が一致していません。',
  'message.BFA000334E': '拡張子が「xlsx」のファイルを選択してください。',
  'message.BFA000362E': '技術検討要否が否または、技術検討結果が「共架可（条件無し）」または「共架可（条件有り 共架申込修正不要）の物件の一束化相手先1~4に「その他（相手不明）」が含まれています。{0}',
  'message.BFA000366E': '支持物単位に全体写真1、全体写真2、拡大写真1をそれぞれ１つ以上登録してください。{0}',
  'message.BFA000377E': '廃止解約申込している共架者、または廃止済の共架者のため、操作できません。',
  'message.BFA000379E': '設備が先行建柱でないため、選択した架設設備は使用できません。他の架設設備を選択してください。{0}',
  'message.BFA000380E': '径間に設定した設備が先行建柱でないため、選択した架設設備は使用できません。他の架設設備を選択してください。{0}',
  'message.BFA000381E': '共架区分に対応する架設設備を選択してください。{0}',
  'message.BFA000382E': '設備が先行建柱のため、しゅん工確認結果は適を選択してください。{0}',
  'message.BFA000392E': '設備の共架区分に対応する架設設備を選択してください。{0}',
  'message.BFA000393E': '架設設備は先行建柱の架設設備です。先行建柱チェックボックスにチェックを入れてください。{0}',
  'message.BFA000394E': '架設設備は先行建柱の架設設備ではありません。先行建柱チェックボックスのチェックを外してください。{0}',
  'message.BFA000395E': '架設設備は先行建柱の架設設備です。架設設備に対応する共架区分を選択してください。{0}',
  'message.BFA000396E': '電柱の所有者が中電ではないため、先行建柱にできません。先行建柱チェックボックスのチェックを外してください。{0}',
  'message.BFA000397E': '電柱の所有者がNTTではないため、先行建柱にできません。先行建柱チェックボックスのチェックを外してください。{0}',
  'message.BFA000398E': '既設径間の架設設備に先行建柱の架設設備を選択することはできません。{0}',

  // 変更連絡
  'message.BFB000071C': '以下の共架者へ通知メールを送信します。\nよろしいですか。\n{0}',
  'message.BFB000072E': '電子通知対象外の事業者が選択されています。',
  'message.BFB000133E': '作成中以外の共架柱変更連絡（{0}）は削除できません。',
  'message.BFB000134E': '工事日情報（工事日または工事中止）が未入力のため連絡共架者一覧を表示できません。',
  'message.BFB000135E': '共架柱変更連絡基本情報入力データが保存されていないため詳細入力画面へ移動できません。',
  'message.BFB000136E': '共架柱変更連絡基本情報入力の対象データが存在しないため保存できません。',
  'message.BFB000137E': '選択項目に誤りがあるため追加できません。電柱番号:{0}',
  'message.BFB000138E': '工事日を変更する場合、変更理由を入力してください。',
  'message.BFB000142W': '依頼内容を確定し、共架者が参照可能となります。よろしいですか。',
  'message.BFB000149I': '{0}を{1}しました。\n共架者一覧画面で電子通知対象を選択し、確定登録してください。',
  'message.BFB000150C': '入力内容を確定し、共架者が移設工事予定日の入力が可能となります。よろしいですか。',
  'message.BFB000151I': '入力内容を確定しました。\n電子通知（メール送信）の操作を行ってください。',
  'message.BFB000152C': '入力内容を確定します。よろしいですか。',
  'message.BFB000165W': '工事予定日（{0}）が他共架者の工事予定日と重複しています。よろしいですか。',
  'message.BFB000168C': '変更連絡の取消を確定します。よろしいですか。',
  'message.BFB000169I': '変更連絡を取消しました。共架者への通知方法を選択し、システム通知を実行してください。',
  'message.BFB000170W': '工事予定日（{0}）が中電工事日と重複しています。よろしいですか。',
  'message.BFB000171W': '工事予定日（{0}）が共架工事可能期間外です。登録してもよろしいですか。',
  'message.BFB000173E': '変更連絡先共架者件数の上限に達しています。',
  'message.BFB000227W': '共架柱として登録されていない移設電柱があります。申込を実施して下さい。電柱番号:{0}',
  'message.BFB000231E': '共架者を削除することができません。',
  'message.BFB000232E': '入力部が正しくありません。',
  'message.BFB000252E': '複数の共架者が選択されています。',
  'message.BFB000250W': '工事予定日（{0}）が他事業者の工事予定日と重複しています。よろしいですか。',
  'message.BFB000260W': '選択した共架柱に共架物件がありません。変更連絡を登録しますか。',
  'message.BFB000277E': '作成中以外の件名は削除できません。',
  'message.BFB000285E': '外線設計情報読込エラーが発生しました。（{0}）',
  'message.BFB000286E': '仮移設本数上限を超えています。',
  'message.BFB000287W': '対象電柱を追加してください。',
  'message.BFB000287E': '対象電柱を追加してください。',
  'message.BFB000288C': '共架柱変更連絡を取消します。よろしいですか。',
  'message.BFB000295E': '径間入力ボタンをクリックし、径間の移設結果を登録してください。',
  'message.BFB000296E': '共架者別対象電柱選択を行ってください。{0}',
  'message.BFB000297E': '変更連絡対象の共架者を追加してください。',
  'message.BFB000303I': '外線設計情報読込で取得した電柱情報は電柱用地マスタに存在しません。{0}',

  // 改修
  'message.BFI000218E': '改修通知済以外は削除不可です。',
  'message.BFD000240E': '改修通知起因で共架申込する場合は、共架申込要否に「要」を登録してください。',
  'message.BFA000253E': 'PG側の改修工事が可能な場合は、配電と通信の改修要否の少なくとも一方は要を登録してください。',

  // その他
  'message.BFZ000106E': '本日から期末日までの日付を入力してください。',
  'message.BFD000162E': '{0}{1}{2}の共架申込が仕掛中となっています。所有権移転することができません、{3}',
  'message.BFU000172E': '通知先の共架者を登録してください。',
  'message.BFM000203E': '一括登録対象外の電柱が含まれています。',
  'message.BFM000204E': '支社は削除不可です。',
  'message.BFD000214E': '所有権移転登録を取消できません。移転日の前日まで取消可能です。',
  'message.BFE000217E': '既に依頼済みです。',
  'message.BFZ000233E': 'メールアドレスに正しい値を入力してください。{0}',
  'message.BFU000234E': '事業者に管理者が一人は存在する設定にしてください。',
  'message.BFD000235E': '支持物を変更する場合、異動種別は変更に設定してください。{0}',
  'message.BFD000241E': '代表電柱が未入力です。',
  'message.BFE000242W': '会計調達システムで、請求書の再印書登録済みでしょうか。\n「はい」であれば、再印書実施日に今日の日付を反映します。\n未実施であれば実施後に再印書ボタンをクリックして下さい。',
  'message.BFD000250E': '新設または廃止の物件を登録する場合は、共架者への通知が必要です。{0}',
  'message.BFD000251E': '{0}のマスタ情報を更新する場合は、共架者への通知が必要です。{1}',
  'message.BFE000250E': '元情報より項目値が変更されていないため、変更登録ができません。',
  'message.BFE000261E': '変更後の請求先を指定してください。',
  'message.BFU000262E': '金融機関コードは数字４桁で入力してください。{0}',
  'message.BFU000263E': '店舗コードは数字３桁で入力してください。{0}',
  'message.BFU000264E': '口座番号はゆうちょ銀行の場合８桁数字、その他の場合７桁数字で入力してください。{0}',
  'message.BFU000265E': '口座名義は半角カナで入力してください。{0}',
  'message.BFE000266E': '請求／払戻金額（税抜き）は元請求の請求金額を超えています。',
  'message.BFE000267E': '請求／払戻金額（税抜き）はマイナス金額を入力してください。',
  'message.BFE000268W': '費用明細の事業場に含まれていない収益事業場を設定されています。処理を継続しますか？',
  'message.BFE000269W': '税率が変更されています。処理を継続しますか？',
  'message.BFE000270E': '請求／払戻金額（税抜き）はプラス金額を入力してください。',
  'message.BFU000275W': '口座番号（{0}）はすでに振替可能ですが、不可で処理を継続してよろしいですか？{0}',
  'message.BFU000276W': '銀行の審査が完了しているか確認してください。{0}',
  'message.BFU000278W': '金融機関コード・店舗コードが正しくない可能性があります。処理を継続しますか？',
  'message.BFU000279E': '金融機関コード・店舗コードが金融機関マスタに存在しません。{0}',
  'message.BFU000280E': '該当するユーザーは存在しません。',
  'message.BFE000281E': '払戻金額が収益事業場に指定された請求金額を上回らないことを確認して下さい。',
  'message.BFD000290C': '共架者を再選択した場合、入力途中の内容は失われます。よろしいですか？',
  'message.BFU000293E': 'ビジネスパートナー、部署・事業所コードに誤りがあります。',
  'message.BFU000294E': '共架料請求先の指定は１社を指定して下さい。',
  'message.BFU000305E': '{0}は１つのみ選択してください。{1}',
  'message.BFM000308E': '電柱用地マスタ登録数の上限を超えてます。',
  'message.BFE000301E': '費用発生日が不正です。請求期間終了日以前の日付を入力してください。',
  'message.BFE000312E': '当請求に工事後精算が含まれていないため、個別払戻登録できません。',
  'message.BFE000315E': '請求確定済み、承認できません。',
  'message.BFU000331E': '{0}は少なくとも1つ請求先を選択してください。',
  'message.BFU000333E': '{0}のため、{1}を選択してください。{2}',
  'message.BFD000339E': '廃止予定の電柱{0}が選択されています。他の電柱を選択してください。{1}',
  'message.BFA000340E': '変更（減条）する径間の第一電柱、第二電柱両方に廃止の設備を選択することはできません。他の異動種別を選択してください。{0}',
  'message.BFA000341E': '新設の径間に廃止、変更（減条）の設備（{0}）を選択できません。他の設備を選択してください。{1}',
  'message.BFA000342E': '変更（増条）の径間に廃止、変更（減条）の設備（{0}）を選択できません。他の設備を選択してください。{1}',
  'message.BFA000343E': '廃止の径間に新設、変更（増条）の設備（{0}）を選択できません。径間を修正してください。{1}',
  'message.BFA000344E': '変更（減条）の径間に新設、変更（増条）の設備（{0}）を選択できません。径間を修正してください。{1}',
  'message.BFA000345E': '変更（その他）の径間に新設、変更（増条）、廃止、変更（減条）の設備（{0}）を選択できません。径間を修正してください。{1}',
  'message.BFA000346E': '径間の{0}が未設定です。設備を選択してください。{1}',
  'message.BFA000347E': '径間に不正な電柱{0}があります。径間を修正してください。{1}',
  'message.BFA000348E': '新設の径間に廃止の設備（{0}）を選択できません。他の設備を選択してください。{1}',
  'message.BFA000349E': '廃止の径間に新設の設備（{0}）を選択できません。径間を修正してください。{1}',
  'message.BFA000350E': '変更の径間に新設、廃止の設備（{0}）を選択できません。径間を修正してください。{1}',
  'message.BFA000351E': '取付手段に直付を選択しているため、取付種別は「引留」、または「通り」を選択してください。{0}',
  'message.BFA000352E': '取付手段に腕金（水平）を選択しているため、取付種別は「腕金（中心側）」、または「腕金（外側）」を選択してください。{0}',
  'message.BFA000353E': '新設の径間に廃止、変更は選択できません。{0}',
  'message.BFA000354E': '既設の径間に新設は選択できません。{0}',
  'message.BFA000355E': '新設の径間に廃止、変更（減条）、変更（その他）は選択できません。{0}',
  'message.BFA000356E': '既設の径間に新設、変更（増条）は選択できません。{0}',
  'message.BFA000358E': 'この契約は現在、電子署名できません。システム管理者にお問い合わせください。',
  'message.BFA000359E': 'この契約はすでに締結されたか、取り下げられています。システム管理者にお問い合わせください。',
  'message.BFA000360I': 'この契約はすでに締結されています。いったんログアウトいただき、再度ログインしてください。',
  'message.BFA000361I': 'この契約は紙面による署名にて締結されます。契約書2部署名の上、署名済み契約書1部を中部電力パワーグリッドへ送付してください。',
  'message.BFU000368E': '支払方法区分と請求書作成区分の組合せが正しくありません。{0}',
  'message.BFA000370E': '改修設計通信要の設備がないため、改修工事差戻できません。',
  'message.BFU000371E': '{0}が{1}に存在しません。{2}',
  'message.BFU000372E': '{0}は既に登録済みです。{1}',
  'message.BFU000373E': '{0}は正しいフォーマット（10桁、または11桁の数値）で入力してください。{1}',
  'message.BFU000374E': '{0}は全角カタカナのみ入力してください。{1}',
  'message.BFU000375E': '{0}メールアドレスに正しい値を入力してください。{1}',
  'message.BFU000376E': '{0}は半角数字のみ入力してください。{1}',
  'message.BFU000380S': 'システム異常が発生しました。\n件数過多により処理がタイムアウトしました。\n一部の共架者に通知が届いていない可能性があります。',
  'message.BFI000380S': 'システム異常が発生しました。\n件数過多により処理がタイムアウトしました。\n一部の宛先に通知が届いていない可能性があります。',
  'message.BFY000401E': '内容編集（更新）する件数を{0}件以下にしてください。',
  'message.BFA000403E': '会社区分：特定（NTT）に応じた正しいポジションリンク（99）を入力してください。{0}',
  'message.BFA000404E': '会社区分：電子通信に応じた正しいポジションリンク（98）を入力してください。{0}',
  'message.BFA000405E': '会社区分に応じた正しいポジションリンク（99,98以外）を入力してください。{0}',
  'message.BFE000406E': '支払方法区分：口座振替の場合、再請求登録はできません。',
  'message.BFI000409C': 'ラジオボタン（ダッシュボード／重要事項通知）\nおよび通知先に間違いはありませんか。',

  // From TKTS for login operation
  'message.TKSCS00001S': 'システム異常が発生しました。\nしばらく待って再度やり直してください。',
  'message.TKSCS00002C': '{0}します。よろしいですか。',
  'message.TKSCS00005E': '{0}を入力してください。{1}',
  'message.TKSCS00018I': '仮パスワードでのログインのため、パスワードを変更してください。',
  'message.TKSCZ00019E': '誤ったユーザIDまたはパスワードが入力されました。\n再度入力してください。',
  'message.TKSCZ00020I': 'パスワードを変更しました。\n新しいパスワードでログインしてください。',
  'message.TKSCZ00021I': [
    'パスワードリセットのメールを送付しました。',
    'メールに記載のURLをクリックして新しいパスワードを入力してください。',
    '',
    '数分経過してもメールが届かない場合、以下をご確認ください。',
    '・迷惑メールに振り分けられている場合があります。',
    '　メールが迷惑メールフォルダに届いていないかご確認ください。',
    '・ドメイン受信設定が必要な場合があります。',
    '　{0}からのメールを受信できるよう設定してください。',
    '・ご入力のユーザIDが誤っている場合があります。',
    '　ユーザIDは大文字と小文字を区別します。',
  ].join('\n'),
  'message.TKSCZ00057E': '前回使用したパスワードは使用できません。\n新しいパスワードを入力してください。',

  // From TKTS for API error handler
  'message.TKSCZ00022E': 'ユーザの有効期限が切れました。管理者に連絡してください。',
  'message.TKSCZ00025E': 'ユーザが無効です。管理者に連絡してください。',
  'message.TKSCS00071E': '該当データが存在しないか、アクセス許可がありません。',
  'message.TKSCS00125E': '該当データが存在しません。',
  'message.TKSCS00126I': 'ユーザ情報が更新されました。\n操作をやり直してください。',
  'message.TKSCS00127I': 'アプリケーションが更新されました。\n操作をやり直してください。',
  'message.TKSCS00128E': 'アクセスが集中しています。少し時間をおいて再度実行してください。',
  'message.TKSCS00129E': '対象件数過多によりタイムアウトしました。\n条件を見直して再度実行してください。',
  'message.TKSCS00130I': '業務時間になりました。\nメニュー項目を更新します。',
  'message.TKSCS00131I': '業務時間外になりました。\nメニュー項目を更新します。',
  'message.TKSCS00132I': '業務時間外になりました。\n現在ご利用いただけません。',
  'message.TKSCS00133I': 'メンテナンス作業中です。\nメニュー項目を更新します。',
  'message.TKSCS00134I': 'メンテナンス作業中です。\n現在ご利用いただけません。',
  'message.TKSCS00135I': 'まもなく業務開始時刻です。',
  'message.TKSCS00136I': 'まもなく業務終了時刻です。',
};
